import { useContext, useRef } from 'react';
import controlPanelLightImg from './tourImages/controlPanelLight.png';
import controlPanelDarkImg from './tourImages/controlPanelDark.png';
import membersDark from './tourImages/membersDark.png';
import membersLight from './tourImages/membersLight.png';
import fpsPingImg from './tourImages/fpsPing.png';
import { ThemeContext } from '@/shared/context';

export const useTour = () => {
  const { themeMode } = useContext(ThemeContext);

  const enterByLinkRef = useRef(null);
  const createNewCallRef = useRef(null);
  const controlButtonsRef = useRef(null);
  const inOutDevicesRef = useRef(null);
  const fpsPingRef = useRef(null);

  const steps = [
    {
      title: 'Страница звонков',
      description:
        'Добро пожаловать в раздел «Звонки» — здесь вы можете оперативно организовать защищённую голосовую и видеосвязь между сервером и устройствами Гроза/Глаз. Удобное управление, лёгкое подключение и полная мобильность.',
      target: null,
    },
    {
      title: 'Войти по ссылке',
      description:
        'Нажмите, чтобы подключиться к существующему звонку — вставьте приглашение, полученное от других участников.',
      target: () => enterByLinkRef.current,
    },
    {
      title: 'Создать новый звонок',
      description: 'Создайте новую комнату и пригласите участников за пару кликов.',
      target: () => createNewCallRef.current,
    },
    {
      title: 'Кнопки управления в комнате звонка',
      cover: <img alt='tour.png' src={themeMode === 'light' ? controlPanelLightImg : controlPanelDarkImg} />,
      description: (
        <>
          <p>- Управлять камерой и микрофоном;</p>
          <p>- Показывать экран другим участникам;</p>
          <p>- Настраивать устройства ввода-вывода и менять битрейт в реальном времени.</p>
        </>
      ),
      target: () => controlButtonsRef.current,
    },
    {
      title: 'Участники звонка',
      cover: <img alt='tour.png' src={themeMode === 'light' ? membersLight : membersDark} />,
      description: (
        <>
          <p>Нажмите, чтобы открыть список участников. Вы можете:</p>
          <p>- Пригласить пользователя напрямую из списка на сервере;</p>
          <p>- Скопировать приглашение для отправки в мессенджерах;</p>
          <p>- Скопировать ссылку для подключения через браузер.</p>
        </>
      ),
      target: () => inOutDevicesRef.current,
    },
    {
      title: 'FPS и Ping',
      cover: <img alt='tour.png' src={fpsPingImg} />,
      description:
        'В реальном времени отображаются FPS и ping участников, что позволяет оперативно оценивать стабильность соединения.',
      target: () => fpsPingRef.current,
    },
  ];

  return {
    enterByLinkRef,
    createNewCallRef,
    controlButtonsRef,
    inOutDevicesRef,
    fpsPingRef,
    steps,
  };
};
